// Palette Okabe-Ito (10 couleurs, accessible WCAG AA, cf. DECISIONS.md §2)
export const TIER_COLORS = [
  '#E69F00', // 1 — Orange
  '#56B4E9', // 2 — Bleu ciel
  '#009E73', // 3 — Vert bleuté
  '#F0E442', // 4 — Jaune
  '#0072B2', // 5 — Bleu
  '#D55E00', // 6 — Vermillon
  '#CC79A7', // 7 — Pourpre rosé
  '#999999', // 8 — Gris neutre
  '#882255', // 9 — Bordeaux
  '#44AA99', // 10 — Turquoise
];

export const getTierColor = (index: number): string =>
  TIER_COLORS[index % TIER_COLORS.length] ?? '#888888';
